/* eslint-disable react/no-find-dom-node,  no-param-reassign, class-methods-use-this */

// node modules
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import Lightbox from 'react-images';
import Skeleton from 'react-loading-skeleton';

// app modules: components
import GeneralContent from 'components/GeneralContent';
import Heading from 'components/Heading';

// app modules: services
import formatter from 'services/formatter';

// app modules: props
import RecipeImageProps from 'components/RecipeImage/RecipeImageProps';

// assets
import CssContentRawDetails from './ContentRawDetails.scss';

class ContentRawDetails extends Component {
  static propTypes = {
    heading: PropTypes.string.isRequired,
    raw: PropTypes.arrayOf(PropTypes.string),
    image: PropTypes.shape({
      credit: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
      primary: PropTypes.string,
      permission: PropTypes.bool,
      type: PropTypes.string,
    }),
    highlightAdjustments: PropTypes.bool,
    loading: PropTypes.bool,
    dualColumn: PropTypes.bool,
    graphics: RecipeImageProps.graphics,
    contentRawAction: PropTypes.node,
  };

  static defaultProps = {
    raw: [],
    image: {
      credit: '',
      primary: '',
      permission: false,
    },
    highlightAdjustments: false,
    loading: false,
    dualColumn: false,
    graphics: [],
    contentRawAction: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      isOpenLightbox: false,
      lightboxImage: null,
    };

    this.bound = {
      transformImages: this.transformImages.bind(this),
      transformHeadings: this.transformHeadings.bind(this),
      openLightbox: this.openLightbox.bind(this),
      closeLightbox: this.closeLightbox.bind(this),
      onImageClick: this.onImageClick.bind(this),
    };
  }

  componentDidMount() {
    const domNode = ReactDOM.findDOMNode(this).parentElement;

    Array.from(domNode.querySelectorAll('.content-raw-details__image')).forEach(image => {
      image.onclick = this.bound.onImageClick;
    });
  }

  onImageClick(event) {
    const { credit, permission } = this.props.image;

    let caption = null;
    if (permission && credit && credit.length) {
      let prefix = '';
      if (Array.isArray(credit)) {
        prefix = credit.find(c => c.includes('Photo:')) ? '' : 'Photo: ';
      }

      if (typeof credit === 'string') {
        prefix = credit.includes('Photo: ') ? '' : 'Photo: ';
      }

      caption = `${prefix}${credit || ''}`;
    }

    this.setState({
      isOpenLightbox: true,
      lightboxImage: {
        src: event.srcElement.getAttribute('src'),
        srcSet: event.srcElement.getAttribute('srcset'),
        style: { maxWidth: event.srcElement.dataset.lightboxMaxWidth },
        caption,
      },
    });
  }

  openLightbox() {
    this.setState({
      isOpenLightbox: true,
    });
  }

  closeLightbox() {
    this.setState({
      isOpenLightbox: false,
    });
  }

  transformImages(DOM) {
    const { primary, permission, type } = this.props.image;

    if (permission) {
      Array.from(DOM.getElementsByTagName('img')).forEach(image => {
        const src = image.getAttribute('src');
        if (src === primary && type === 'primary') {
          image.parentNode.removeChild(image);
        } else {
          image.setAttribute('class', 'content-raw-details__image');
        }
      });
    } else {
      formatter.xml.removeAll(DOM, 'img');
    }

    // Don't leave any empty figure tags hanging around - they upset formatting of subsequent sections
    Array.from(DOM.getElementsByTagName('figure')).forEach(figure => {
      if (figure.childNodes.length === 0) {
        figure.parentNode.removeChild(figure);
      }
    });
  }

  transformHeadings(DOM) {
    const { heading } = this.props;

    Array.from(DOM.getElementsByTagName('h3')).forEach(element => {
      if (element.textContent.toLowerCase() === heading.toLowerCase()) {
        element.parentNode.removeChild(element);
      }
    });
  }

  renderRaw() {
    const { heading, raw, highlightAdjustments, loading, dualColumn, graphics } = this.props;
    if (!raw) {
      return null;
    }
    return raw.map((rawItem, rawItemIndex) => {
      const rawKey = `content-raw-details-${heading.toLowerCase()}-${rawItemIndex}`;
      return (
        <GeneralContent
          key={rawKey}
          raw={rawItem}
          highlightAdjustments={highlightAdjustments}
          beforeTransform={[this.bound.transformImages, this.bound.transformHeadings]}
          loading={loading}
          skeletonProps={{ count: 10 }}
          dualColumn={dualColumn}
          graphics={graphics}
        />
      );
    });
  }

  render() {
    const { heading, loading, raw, contentRawAction } = this.props;
    const { lightboxImage } = this.state;

    return (
      <div className="content-raw-details">
        <Heading className="margin-bottom-20">
          {loading && (!raw || !raw[0]) ? <Skeleton width="25%" /> : heading}
        </Heading>
        {contentRawAction && <div className="content-raw-details__action">{contentRawAction}</div>}
        {this.renderRaw()}
        {this.state.isOpenLightbox && lightboxImage ? (
          <Lightbox
            backdropClosesModal
            images={[lightboxImage]}
            isOpen
            onClose={this.bound.closeLightbox}
            showImageCount={false}
            width={2000}
            theme={{ image: { userSelect: 'none', pointerEvents: 'none', ...lightboxImage.style } }}
          />
        ) : null}
      </div>
    );
  }
}

export default withStyles(CssContentRawDetails)(ContentRawDetails);
